import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { GlobalService } from '../../../core/services/global.service';
import { Observable } from 'rxjs';
import { DataTransferService } from '../../../core/services/data-transfer.service';

@Component({
	selector: 'app-location-typeahead',
	templateUrl: './location-typeahead.component.html',
	styleUrls: ['./location-typeahead.component.scss']
})

export class LocationTypeaheadComponent implements OnInit, OnChanges {

	@Input() placeHolder: any;
	@Input() placeModel: any;
	@Output() locationSelected = new EventEmitter();
	@Input() locationAddress: any;
	@Input() formType = true;
	@Input() selectedUser: string;
	user: any;
	resultsPresent = false;
	noRecords = false;
	searchText = '';
	selectedLocation = '';
	savedList = [];
	locationList = [];

	constructor(
		private apiService: ApiService,
		private dataTransferService: DataTransferService,
		public globalService: GlobalService) { }

	ngOnInit() {
		this.searchText = '';

		this.searchText = this.locationAddress;
		this.user = localStorage.getItem('userId');
		this.dataTransferService.getCurrentUser().subscribe(
			user => {
				this.user = user;
			});
		this.dataTransferService.getAddLocation().subscribe(
			value => {
				if (value != 'initialState') {
					this.searchText = '';
					this.locationList = [];
				}
			}
		);
	}

	ngOnChanges(changes: SimpleChanges) {
		this.searchText = this.locationAddress;
	}

	getSavedLoacations() {
		const params = {
			id: this.user
		};
		this.apiService.getSavedLocations(params.id).subscribe(
			response => {
				this.savedList = response.data.locations;
				this.filterSavedLocations(this.savedList);
			},
			error => {
			}
		);
	}

	searchForLocations(event) {
		this.searchText = event;
		this.savedList = [];
		this.locationList = [];
		if (this.searchText.length > 2) {
			this.getSavedLoacations();
			this.resultsPresent = true;
			this.noRecords = false;
			this.searchForLocationsAPI(this.searchText);
		}
	}

	filterSavedLocations(locations) {
		const searchResults = locations.filter(location => location.location_name.toLowerCase().includes(this.searchText.toLowerCase()));
		this.conditionSavedData(searchResults);
	}

	searchForLocationsAPI(searchText: string) {
		const params = {
			location: searchText
		};

		this.apiService.getGooglePlaces(params).subscribe(
			response => {
				if (response.predictions) {
					this.locationList = response.predictions;
					this.conditionLocationData(this.locationList);
				} else {
					this.noRecords = true;
				}
			},
			error => {
			}
		);
	}

	selectItem(location) {
		this.resultsPresent = false;
		this.searchText = location.name;
		this.selectedLocation = location;
		this.locationSelected.emit(location);
	}

	conditionSavedData(locations) {
		const savedConditioned = locations.map(location => {
			return {
				latitude: location.latitude,
				location_name: location.location_address,
				longitude: location.longitude,
				name: location.location_name,
				placeId: location.place_id
			};
		});
		this.savedList = savedConditioned;
	}

	conditionLocationData(locations) {
		if (locations.length) {
			const locationsConditioned = locations.map(location => {
				return {
					reference: location.reference,
					location_name: location.description,
					placeId: location.place_id,
					name: location.description
				};
			});
			this.locationList = locationsConditioned;
		} else {
			this.noRecords = true;
		}
	}

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/components/location-typeahead/location-typeahead.component.ts